import React, { useMemo, useState } from 'react';
import WiringPage, { CompactButtons, WiringSelect } from '../../wiring-page';

import wirelessImg from '../../../../assets/product-interaction/ddsu5168-4p/ddsu5168_4p_wireless_4g.png';
import gw214Img from '../../../../assets/product-interaction/ddsu5168-4p/ddsu5168_4p_rs485_gw214.png';
import gw152Img from '../../../../assets/product-interaction/ddsu5168-4p/ddsu5168_4p_rs485_gw152.png';
import master4pImg from '../../../../assets/product-interaction/ddsu5168-4p/ddsu5168_4p_rs485_master_4p.png';

const diagrams = [
  {
    id: 'wireless',
    connection: 'wireless',
    title: '无线版接线图',
    tag: '4G',
    image: wirelessImg,
    imageAlt: 'DDSU5168 4P 无线版本接线图',
    className: 'wiring-diagram-wireless'
  },
  {
    id: 'gw214',
    connection: 'wired',
    gateway: 'gw214',
    title: '有线版接线图',
    tag: 'GW214',
    image: gw214Img,
    imageAlt: 'DDSU5168 4P 有线版本连接 GW214 网关接线图'
  },
  {
    id: 'gw152',
    connection: 'wired',
    gateway: 'gw152',
    title: '有线版接线图',
    tag: 'GW152',
    image: gw152Img,
    imageAlt: 'DDSU5168 4P 有线版本连接 GW152 网关接线图'
  },
  {
    id: 'master4p',
    connection: 'wired',
    gateway: 'master4p',
    title: '有线版接线图',
    tag: '4P 母表',
    image: master4pImg,
    imageAlt: 'DDSU5168 4P 有线版本连接 4P 母表接线图'
  }
];

const connectionOptions = [
  { value: 'all', label: '全部' },
  { value: 'wireless', label: '无线' },
  { value: 'wired', label: '有线' }
];

const gatewayOptions = [
  { value: 'all', label: '全部采集器' },
  { value: 'gw214', label: 'GW214' },
  { value: 'gw152', label: 'GW152' },
  { value: 'master4p', label: '4P母表' }
];

const DDSU5168FourPoleWiring = () => {
  const [connection, setConnection] = useState('all');
  const [gateway, setGateway] = useState('all');

  const handleConnectionChange = (value) => {
    setConnection(value);
    if (value !== 'wired') setGateway('all');
  };

  const visibleDiagrams = useMemo(() => diagrams.filter((diagram) => {
    if (connection !== 'all' && diagram.connection !== connection) return false;
    return connection !== 'wired' || gateway === 'all' || diagram.gateway === gateway;
  }), [connection, gateway]);

  const filters = (
    <>
      <CompactButtons
        ariaLabel="通讯版本"
        className="wiring-connection-filter"
        options={connectionOptions}
        value={connection}
        onChange={handleConnectionChange}
      />
      {connection === 'wired' && (
        <WiringSelect
          ariaLabel="采集器"
          options={gatewayOptions}
          value={gateway}
          onChange={setGateway}
        />
      )}
    </>
  );

  return (
    <WiringPage
      documentTitle="DDSU5168 4P 接线图｜源一物联"
      heading="DDSU5168 4P"
      backUrl="/product/ddsu5168-4p"
      filters={filters}
      diagrams={visibleDiagrams}
    />
  );
};

export default DDSU5168FourPoleWiring;
